import HttpService from "./htttp.service";

class TemplateCategoriesService {
  getTemplateCategories = async (query, cancelToken) => {
    const endpoint = "sheet-template-categories";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createTemplateCategory = async (payload) => {
    const endpoint = "sheet-template-categories";
    return await HttpService.post(endpoint, payload);
  };

  removeTemplateCategory = async (id) => {
    const endpoint = "sheet-template-categories/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateTemplateCategory = async (id, payload) => {
    const endpoint = "sheet-template-categories/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new TemplateCategoriesService();
